module.exports = __webpack_public_path__ + "static/media/polanco.03a21617.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/polanco.png
// module id = 615
// module chunks = 0